
export default function ServiceOverview() {
  return (
    <section className="py-12 sm:py-16 md:py-20 px-4 sm:px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-8 sm:mb-12 md:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">
            サービス概要
          </h2>
          <p className="text-sm sm:text-base text-gray-600 max-w-3xl mx-auto leading-relaxed">
            医療従事者の皆様の研究・診療活動をサポートする、<br className="hidden sm:inline" />
            論文検索・入手代行サービスです。
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          <div className="bg-gradient-to-br from-blue-50 to-white rounded-2xl p-6 sm:p-8 shadow-md hover:shadow-lg transition-all border border-blue-100">
            <div className="w-12 h-12 sm:w-14 sm:h-14 bg-blue-600 text-white rounded-full flex items-center justify-center mb-4 sm:mb-6">
              <i className="ri-search-line text-2xl sm:text-3xl"></i>
            </div>
            <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-3">
              論文検索
            </h3>
            <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">
              ご希望のテーマやキーワードに基づき、国内外の医学文献データベースから最適な論文を検索します。
            </p>
          </div>

          <div className="bg-gradient-to-br from-teal-50 to-white rounded-2xl p-6 sm:p-8 shadow-md hover:shadow-lg transition-all border border-teal-100">
            <div className="w-12 h-12 sm:w-14 sm:h-14 bg-teal-600 text-white rounded-full flex items-center justify-center mb-4 sm:mb-6">
              <i className="ri-file-download-line text-2xl sm:text-3xl"></i>
            </div>
            <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-3">
              論文入手
            </h3>
            <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">
              図書館および出版社から正規の手続きで論文を入手しており、著作権法を遵守した適正な文献のみを提供しております。安心してご利用いただけます。
            </p>
          </div>

          <div className="bg-gradient-to-br from-purple-50 to-white rounded-2xl p-6 sm:p-8 shadow-md hover:shadow-lg transition-all border border-purple-100">
            <div className="w-12 h-12 sm:w-14 sm:h-14 bg-purple-600 text-white rounded-full flex items-center justify-center mb-4 sm:mb-6">
              <i className="ri-file-text-line text-2xl sm:text-3xl"></i>
            </div>
            <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-3">
              概要作成
            </h3>
            <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">
              論文の要点をまとめたサマリーや翻訳サービスもご用意。時間を節約し、効率的に情報を把握できます。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
